import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHistory } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from 'react-confirm-alert'; // Import
import ConfirmUI from '../../ui/Confirm.js';
import ShowIff from '../../ui/ShowIff.js';

import convert from 'convert-units';

import Box from '../../ui/Box.js';
import Loadable from '../../ui/loading/Loadable.js';
import Distance from '../../ui/Distance.js';

import api from '../../../api/index.js';
import cache from '../../../api/cache.js';

import DeadPlantsForm from './deadplantsform.js';

import './row.scss';

class RowSummary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			detailsOpen: false,
			deadplants: false,
			showHistory: false
		};
		this.onClick = this.onClick.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onDeadPlantHistory = this.onDeadPlantHistory.bind(this);
		this.onAdded = this.onAdded.bind(this);
	}
	
	percent(val) {
		return val/this.props.max * 100;
	}
	
	
	onClick() {
		// Pop up the row status window.  Which will have a thing to open the dead plants window.
		this.setState({detailsOpen: true});
	}
	
	onClose() {
		this.setState({detailsOpen: false});
	}
	
	onAdded() {
		this.onClose();
		if (this.props.onChange)
			this.props.onChange();
	}
	
	async onDeadPlantHistory() {
		// Fetch the history, and mark it as [toshow] in the state.
		this.setState({showHistory: true});
		try {
			let r = await api.get('farms/' + this.props.field.FarmID + '/fields/' + this.props.field.FieldID + '/rows/' + this.props.row.RowID + '/dead');
			this.setState({deadplants: r});
		} catch(e) {
			api.handleExceptions(e);
		}
	}
	
	distance(d) {
		let val = convert(parseFloat(d)).from('cm').to(this.props.displayUnits);
		const precision = this.props.precision || 2;
		const mult = Math.pow(10,precision);
		val = Math.round(val*mult)/mult;
		return val + ' ' + this.props.displayUnits;
	}
	
	
	deleteRowClick = (e) =>  {
		e.preventDefault();
		confirmAlert({
			title: 'Delete row ' + this.props.row.RowNumber + ' from the system',
			customUI: ConfirmUI(
				this.deleteRow,
				<div><p className="red"><em><strong>This is not a safe action.</strong></em></p><p>Avoid this unless you've entered this row by mistake. Are you sure you want to delete this row?</p></div>
			),
		});
	}
	
	deleteRow = async () => {
		try {
			let r = await api.del('farms/' + this.props.field.FarmID + '/fields/' + this.props.field.FieldID + '/rows/delete/' + this.props.row.RowID);
			api.success('Row deleted', r);
			if (this.props.onChange)
				this.props.onChange();
			this.onClose();
		} catch(e) {
			api.handleExceptions(e);
		}
	}


	discontinueRow = async (e) => {
		e.preventDefault();
		try {
			let r = await api.del('farms/' + this.props.field.FarmID + '/fields/' + this.props.field.FieldID + '/rows/discontinue/' + this.props.row.RowID);
			api.success('Row discontinued', r);
			if (this.props.onChange)
				this.props.onChange();
			this.onClose();
		} catch(e) {
			api.handleExceptions(e);
		}
	}
	
	render() {
		if (!this.props.field || !this.props.row) {
			console.log('invalid', this.props);
			return '';
		}
		const row_spacing = this.percent(this.props.field.RowSpacing/2);
		// plant distance/max
		// width = rowLength/max
		// We need a thing on the left for row number.. so if we make that like.. 3em.  We can calc the rest of the size
		
		// On click, pop up the interface to add more dead plants
		
		let number_of_plants = Math.floor(this.props.row.RowLength/this.props.field.PlantSpacing);
		const dead_plants = this.props.deadPlants;
		
		let deadplants = '';
		const windowStart = cache.get('daterange.start');
		const windowEnd = cache.get('daterange.end');
		
		
		if (this.state.showHistory) {
			let data = [];
			if (this.state.deadplants !== false) {
				for(let i=0; i < this.state.deadplants.length; i++) {
					let d = api.date(this.state.deadplants[i].EffectiveDate);
					let cname = (d >= windowStart && d <= windowEnd) ? "in-window" : "out-of-window";
					data.push(<tr className={cname} key={i}><td>{this.state.deadplants[i].EffectiveDate}</td><td>{this.state.deadplants[i].DeadPlantNum}</td></tr>);
				}
			}
			deadplants = (<Loadable ready={this.state.deadplants !== false}>
				<table className="deadplants"><thead><tr><th>Effective date</th><th>Number dead</th></tr></thead><tbody>
				{data}
				</tbody></table>
				</Loadable>);
		}
		return (
			<div>
			<div className={"row" + (this.props.discontinued ? " discontinued" : "") + (this.props.row.selected ? " selected" : "")} onClick={this.props.onClick ? this.props.onClick : this.onClick} style={{
				width: this.percent(this.props.row.RowLength) + "%",
				marginTop: row_spacing + '%',
				marginBottom: row_spacing + '%',
			}} title={"Row length: " + this.distance(this.props.row.RowLength) + "\nPlant Spacing: " + this.distance(this.props.field.PlantSpacing) + "\nNumber of plants: " + number_of_plants + "\nDead plants: " + dead_plants}><span className="RowNumber">{this.props.row.RowNumber}</span><div className="dead" style={{
				width: (dead_plants/number_of_plants)*100 + '%'
			}}></div></div>
			<Box modal={true} isOpen={this.state.detailsOpen} onRequestClose={this.onClose} title={"Row " + this.props.row.RowNumber + " – details"}>
				<ShowIff iff={this.props.discontinued}>
					<p className="rowdiscontinued">Discontinued on {this.props.row.DiscontinuedDate}</p>
				</ShowIff>
				<table className="rowDetails">
					<tbody>
					<tr>
						<th>Row length</th>
						<td><Distance value={this.props.row.RowLength} /></td>
					</tr>
					<tr>
						<th>Plant spacing</th>
						<td><Distance value={this.props.field.PlantSpacing} /></td>
					</tr>

					<tr>
						<th>Number of plants</th>
						<td>{number_of_plants}</td>
					</tr>

					<tr>
						<th>Dead plants</th>
						<td>{dead_plants} <FontAwesomeIcon icon={faHistory} title="Historical dead plants" className="historyIcon" onClick={this.onDeadPlantHistory} /></td>
					</tr>
					</tbody>
				</table>
				{deadplants}
				<hr />
				<DeadPlantsForm FarmID={this.props.field.FarmID} FieldID={this.props.field.FieldID} RowID={this.props.row.RowID} RowNumber={this.props.row.RowNumber} onUpdated={this.onAdded} />
				<hr />
				<button className="block" onClick={this.discontinueRow}>Discontinue row</button>
				<button className="block red" onClick={this.deleteRowClick}>Delete row</button>

			</Box>
			</div>
			// I need a distance display component.  That just takes a cm distance and displays as [whatever unit], rounded to X decimal points, default 2 but defined by props.
			
		);
	}
}

export default RowSummary;
